import { ExclamationCircleOutlined } from '@ant-design/icons';
import React, { ReactElement } from 'react';

function CcxIconExclamationCircle(): ReactElement {
    return <ExclamationCircleOutlined />;
}

export default CcxIconExclamationCircle;
